/** 口令强度：≥8，含大写+小写+数字（前后端同一套规则文案） */
export function validatePasswordStrength(password: string): string | null {
  if (!password) return '密码不能为空';
  if (password.length < 8) return '密码长度至少 8 位';
  if (!/[A-Z]/.test(password)) return '密码须包含至少 1 个大写字母';
  if (!/[a-z]/.test(password)) return '密码须包含至少 1 个小写字母';
  if (!/[0-9]/.test(password)) return '密码须包含至少 1 个数字';
  return null;
}

export const PASSWORD_RULE_HINT = '密码至少 8 位，须包含大写字母、小写字母和数字';
